var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.asyncLoading)?_c('div',{staticClass:"one-year-promotion-flow"},[(_vm.isPayment)?_c('one-year-promotion-payment',{attrs:{"done":_vm.goToDone,"action":_vm.goToHome}}):_c('one-year-promotion-done',{attrs:{"payment-info":_vm.paymentInfo}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }